<template>
    <app-dialog
        width="700px"
        :value="value"
        :title="$t('profiles.editUserProfiles')"
        v-bind="$attrs"
        @input="onDialogInput"
    >
        <template v-slot:content>
            <v-form ref="form" lazy-validation>
                <div class="px-3">
                    <v-row class="my-0">
                        <v-col cols="12">
                            <v-text-field
                                v-model="currentItem.name"
                                :disabled="true"
                            >
                                <template v-slot:label>
                                    <span>{{ $t('userDetails.name') }}</span>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-0">
                        <v-col cols="12">
                            <v-text-field
                                :disabled="true"
                                :label="$t('orders.affinity.deliveryAddress')"
                                v-model="currentItem.email"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-0">
                        <v-col cols="12" style="height: 300px">
                            <label
                                class="v-label v-label--active v-label--is-disabled theme--light"
                                >{{ $t('profiles.associated') }}</label
                            >
                            <multiselect
                                id="ajax"
                                autocomplete="none"
                                :placeholder="$t('profiles.addToUser')"
                                :multiple="true"
                                :searchable="true"
                                name="perfis"
                                label="name"
                                track-by="name"
                                v-model="currentItem.selected_profiles"
                                :internal-search="true"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="100"
                                :max-height="200"
                                :show-no-results="true"
                                :hide-selected="false"
                                :show-labels="false"
                                :preserveSearch="true"
                                :custom-label="customLabel"
                                :options="profilesList"
                            >
                                <template slot="singleLabel" slot-scope="props"
                                    ><span class="option__desc"
                                        ><span class="option__title">{{
                                            props.option.name
                                        }}</span></span
                                    ></template
                                >
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc">
                                        <span class="option__title"
                                            >{{ props.option.name }}
                                        </span>
                                    </div>
                                </template>
                                <span slot="noOptions"></span>
                                <span slot="noResult">{{ $t('profiles.noResults') }}</span>
                            </multiselect>
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </template>

        <template v-slot:buttons="{}">
            <v-btn
                text
                outlined
                class="myprovet-btn-cancel"
                @click="onCloseDialog"
            >
                {{ tb('Cancelar') }}
            </v-btn>

            <v-btn text class="myprovet-btn-ok" @click="save">
                {{ tb('Gravar') }}
            </v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { i18n } from '@/i18n';
import { axios } from "@/Services/Backend";
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    data() {
        return {
            currentItem: null,
            default_profile_user: {
                user_id: null,
                name: null,
                email: null,
                selected_profiles: [],
            },
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
            },
        };
    },

    created() {
        this.copyOriginalData();
    },

    props: {
        value: { default: false },
        originalUser: Object,
        branchId: String,
        profilesList: Array,
    },

    methods: {
        customLabel(value) {
            if (value.name) {
                return `${value.name}`;
            } else return `${value}`;
        },
        copyOriginalData() {
            let clone = _.cloneDeep(this.originalUser);
            this.currentItem = _.clone(this.default_profile_user);
            this.currentItem.user_id = clone.id;
            this.currentItem.name = clone.name;
            this.currentItem.email = clone.email;
            this.currentItem.profiles = clone.profiles;
            this.currentItem.selected_profiles = [];

            _.each(clone.profiles, (o) => {
                let rs = _.find(this.profilesList, { id: o.profile_id });
                if (rs) {
                    this.currentItem.selected_profiles.push(rs);
                }
            });
        },

        save() {
            this.loading = true;
            axios.post(
                    "/api/profiles/user-profile",
                    this.currentItem
                )
                .then((data) => {
                    this.showSuccess(this.$t('profiles.userSaved'));
                    this.$emit("on-success", true);
                    window.EventBus.$emit("update:profiles-list", true);
                })
                .catch((data) => {
                    this.showError(
                        this.$t('profiles.genericError')
                    );
                    this.loading = false;
                });
        },

        onDialogInput(event) {
            if (!event) {
                this.$emit("on-cancel", false);
            }
        },

        onCloseDialog() {
            this.$emit("on-cancel", false);
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
